import { render, staticRenderFns } from "./ListPageV2.vue?vue&type=template&id=0dadafe0&scoped=true"
import script from "./ListPageV2.vue?vue&type=script&lang=js"
export * from "./ListPageV2.vue?vue&type=script&lang=js"
import style0 from "./ListPageV2.vue?vue&type=style&index=0&id=0dadafe0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dadafe0",
  null
  
)

export default component.exports